import React from "react";
import { motion } from "framer-motion";
import testimage1 from "../assets/images/chemhere.jpg";
import testimage2 from "../assets/images/sarah.png";

const testimonials = [
  {
    name: "Sarah Matambanadzo",
    role: "CTO at TechCorp",
    image: testimage2,
    text: "Obert is a true standout in the tech industry. His ability to deliver high-quality code while maintaining exceptional attention to detail is rare. His innovative solutions have significantly improved our product's performance and user experience.",
  },
  {
    name: "Michael Chemhere",
    role: "Engineering Manager, WorthTech Systems",
    image: testimage1,
    text: "I've had the pleasure of working with Obert on multiple complex projects. His technical expertise in modern technologies is outstanding, and his ability to solve complex problems quickly is exceptional. Any company would be lucky to have him on their team.",
  },
  {
    name: "Emily Roberts",
    role: "Product Lead, NashCans Ltd",
    image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&auto=format&fit=facearea&q=80",
    text: "Obert's work ethic and passion for technology are truly inspiring. He consistently delivers results that exceed expectations and brings innovative solutions to the table.",
  },
];

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.15 }
  }
};

const cardVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1, y: 0,
    transition: { type: "spring", stiffness: 80 }
  }
};

const Testimonials = () => {
  return (
    <section id="testimonials" className="py-24 relative overflow-hidden bg-slate-950">
      <div className="absolute inset-0 bg-grid opacity-20" />
      <div className="section-container relative z-10">
        <motion.div
          className="text-center mb-16"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={containerVariants}
        >
          <motion.span
            className="inline-block px-4 py-1.5 mb-4 text-xs font-mono tracking-wider text-cyan-400 border border-cyan-500/30 rounded-full bg-cyan-500/5"
            variants={cardVariants}
          >
            Testimonials
          </motion.span>
          <motion.h2
            className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4"
            variants={cardVariants}
          >
            What People <span className="gradient-text">Say</span>
          </motion.h2>
        </motion.div>
        <motion.div
          className="grid grid-cols-1 md:grid-cols-3 gap-6"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              className="glass-card rounded-2xl p-6 hover:border-cyan-500/20 transition-all duration-300"
              variants={cardVariants}
              whileHover={{ y: -4 }}
            >
              <div className="flex flex-col items-center text-center space-y-4">
                <div className="relative">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-20 h-20 rounded-full border-2 border-cyan-500/30 shadow-lg object-cover"
                  />
                  <div className="absolute -top-1 -right-1 bg-cyan-500 rounded-full w-4 h-4 border-2 border-slate-950" />
                </div>
                <p className="text-slate-400 text-sm leading-relaxed italic">
                  "{testimonial.text}"
                </p>
                <div>
                  <h3 className="text-white font-semibold text-sm">{testimonial.name}</h3>
                  <p className="text-slate-500 text-xs">{testimonial.role}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonials;
